/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CollapseRepliesConfig_formValues = {
    readonly collapseReplies: boolean;
    readonly " $refType": "CollapseRepliesConfig_formValues";
};
export type CollapseRepliesConfig_formValues$data = CollapseRepliesConfig_formValues;
export type CollapseRepliesConfig_formValues$key = {
    readonly " $data"?: CollapseRepliesConfig_formValues$data;
    readonly " $fragmentRefs": FragmentRefs<"CollapseRepliesConfig_formValues">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CollapseRepliesConfig_formValues",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "collapseReplies",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'bd1e1dd91a81b90ede8f1c420d50b168';
export default node;
